import type { TransferOrderWorkspaceQueue } from '../transfer-order-workspace-queues.js';
import { transferOrderQueueDefinition } from './transfer-order-queue-definition.js';

export function isStatusCompatibleWithQueue(
  queue: TransferOrderWorkspaceQueue,
  statusId: number,
): boolean {
  const { statusIds } = transferOrderQueueDefinition(queue);
  return statusIds === null || statusIds.includes(statusId);
}
